// extracted by mini-css-extract-plugin
module.exports = {"borderBox":"borderBox___rk7Qu","flexCenter":"flexCenter___j6S55","closeIcon":"closeIcon___1Iy1B"};